import React from 'react';
import currencyToSymbolMap from 'currency-symbol-map/map';
import { Money } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { EXPERIMENTS, VIEWER_HOOKS } from '../../../../../constants';
import { usePrice } from '../../../../../hooks';
import { classes as commonClasses } from '../../../../../styles/common.st.css';
import { st, classes } from './Price.st.css';

interface Props {
  price?: Money;
  highlighted: boolean;
}

export const Price: React.FC<Props> = ({ price: money, highlighted }) => {
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const { price, currency } = usePrice(money?.value, money?.currency);
  const priceFormatterEnabled = experiments.enabled(EXPERIMENTS.PRICE_FORMATTER);

  return (
    <div data-hook={VIEWER_HOOKS.PLAN_PRICE} className={st(classes.wrapper, { highlighted, mobile: isMobile })}>
      <span aria-hidden="true" data-hook={VIEWER_HOOKS.PRICE_CURRENCY} className={classes.currency}>
        {priceFormatterEnabled ? currency : currencyToSymbol(money?.currency)}
      </span>
      <span aria-hidden="true" data-hook={VIEWER_HOOKS.PRICE_AMOUNT} className={classes.price}>
        {priceFormatterEnabled ? price : formatPrice(money)}
      </span>
      <span data-hook={VIEWER_HOOKS.PLAN_PRICE_SCREEN_READER} className={commonClasses.srOnly}>
        {priceFormatterEnabled ? price + currency : formatPrice(money) + currencyToSymbol(money?.currency)}
      </span>
    </div>
  );
};

function formatPrice(price?: Money) {
  const [amount, fraction] = price?.value?.toString().split('.') ?? [];
  if (fraction && fraction.length) {
    return amount + '.' + fraction + (fraction.length > 1 ? '' : '0');
  }
  return amount;
}

export function currencyToSymbol(code?: string): string {
  if (typeof code === 'string') {
    return currencyToSymbolMap[code.toUpperCase()] || code;
  }
  return '';
}
